import React from "react";
import WarningIcon from "@mui/icons-material/Warning";
import { Box, Button, Stack } from "@mui/material";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import { useTranslation } from "react-i18next";

interface IErrorPanelProps {
  title?: string;
  message?: string;
  children: React.ReactNode;
}

export const ErrorPanelComponent: React.FC<IErrorPanelProps> = ({
  title,
  children,
}) => {
  const { t } = useTranslation();

  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <Card>
      {title ? (
        <CardHeader
          avatar={
            <Box sx={{ ml: "auto" }}>
              <WarningIcon />
            </Box>
          }
          title={t("Error_Title_Warning")}
          subheader={title}
        />
      ) : (
        ""
      )}{" "}
      <CardContent>{children}</CardContent>
      <CardActions>
        <Stack direction="row" alignItems="center" sx={{ width: "100%" }}>
          <Box sx={{ ml: "auto" }}>
            <Button variant="outlined" onClick={refreshPage}>
              {t("Error_Button_ReloadPage")}
            </Button>
          </Box>
        </Stack>
      </CardActions>
    </Card>
  );
};
